module.exports = "pegasus_template/assets/circleline-facebook.gif";